export { default } from './jobsBulkAd';
